export const logger=(prefix,item)=>{
    if(process.env.NODE_ENV==='development'){
        item ?  console.log(prefix,item):console.log(prefix);
    }
}